import { Navigate, Outlet } from "react-router-dom";

export default function GuestOnlyRoute({ role }) {
  if (role === "Admin") return <Navigate to="/students" replace />;
  if (role === "User") return <Navigate to="/home" replace />;
  return <Outlet />;
}
